import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { formValues, schema } from "./validations";
import {
  ACTUAL_DURATION,
  ACTUAL_END_DATE,
  ACTUAL_START_DATE,
  PERCENTAGE,
  TASK_STATUS,
} from "./consts";
import { zodResolver } from "@hookform/resolvers/zod";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useActualTask = () => {
  const form = useForm<formValues>({
    defaultValues: {
      [ACTUAL_START_DATE]: "",
      [ACTUAL_END_DATE]: "",
      [PERCENTAGE]: "",
      [TASK_STATUS]: "",
      [ACTUAL_DURATION]: "",
    },
    resolver: zodResolver(schema),
  });

  const taskData = useSelector((state: RootState) => state.currentData.taskData);

  useEffect(() => {
    if (taskData) {
      form.reset({
        [ACTUAL_START_DATE]: taskData?.[ACTUAL_START_DATE] ? moment(taskData?.[ACTUAL_START_DATE]).format("MM-DD-YYYY") : "",
        [ACTUAL_END_DATE]: taskData?.[ACTUAL_END_DATE] ? moment(taskData?.[ACTUAL_END_DATE]).format("MM-DD-YYYY") : "",
        [PERCENTAGE]: taskData?.[PERCENTAGE]?.toString() || "",
        [TASK_STATUS]: taskData?.[TASK_STATUS] || "",
        // [ACTUAL_DURATION]: taskData?.[ACTUAL_DURATION] ||"",
      })
      setDuration(taskData?.[ACTUAL_START_DATE], taskData?.[ACTUAL_END_DATE])
    }
  }, [taskData])

  const setDuration = (startDate: any, endDate: any) => {
    if (startDate && endDate) {
      form.setValue(
        ACTUAL_DURATION,
        moment(endDate).diff(moment(startDate), "days").toString()
      );
    }
  };

  return {
    form,
  };
};

export default useActualTask;
